export default __webpack_public_path__ + "static/media/Bruiser.ccce6798.jpg";